
import Vue from 'vue';
import { TransformedLegalPage } from '~/transforms/transformPages';

export default Vue.extend({
  name: 'legalPage',
  props: {
    pageData: {
      type: Object as () => TransformedLegalPage,
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      window.UC_UI.closeCmp();
      document
        .querySelector<HTMLElement>('.open-cookie-layer')
        ?.addEventListener('click', () => window.UC_UI.showSecondLayer());
    }, 500);
  },
  async destroyed() {
    if (await window.UC_UI.isConsentRequired()) {
      window.UC_UI.showFirstLayer();
    }
    document
      .querySelector<HTMLElement>('.open-cookie-layer')
      ?.removeEventListener('click', () => window.UC_UI.showSecondLayer());
  },
});
